module.exports = __webpack_public_path__ + "img/DOWNLOAD.4c188d79.svg";